<template>
<div>
  <div>
    <label :for="field.id">{{label}} </label>
    <v-select :id="field.id" v-model="model" :items="values" :menu-props="{ maxHeight: '400' }" class="wrap-label"
              item-text="value"
              item-value="key"></v-select>
  </div>
  {{ description }}
</div>
</template>

<script>
import {
  input
} from '@/mixins/input'

export default {
  mixins: [input],
  computed: {
    lang() {
      return this.$store.state.lang
    },
    values() {
      return this.field.values
    }
  },
}
</script>

<style>

</style>
